// src/components/manager/calendarUtils.js
export function toYMD(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

export function getRangeWindow(rangeKey, today = new Date()) {
  const base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startOfWeek = (d) => {
    const tmp = new Date(d); const dow = tmp.getDay(); const offset = (dow === 0 ? -6 : 1 - dow);
    tmp.setDate(tmp.getDate() + offset);
    return new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate());
  };
  const endOfWeek = (d) => { const s = startOfWeek(d); const e = new Date(s); e.setDate(s.getDate() + 6); return e; };
  const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
  const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
  let fromDate, toDate;
  switch (rangeKey) {
    case 'last_week': { const b = new Date(base); b.setDate(b.getDate() - 7); fromDate = startOfWeek(b); toDate = endOfWeek(b); break; }
    case 'next_week': { const b = new Date(base); b.setDate(b.getDate() + 7); fromDate = startOfWeek(b); toDate = endOfWeek(b); break; }
    case 'this_month': { fromDate = startOfMonth(base); toDate = endOfMonth(base); break; }
    case 'this_week':
    default: { fromDate = startOfWeek(base); toDate = endOfWeek(base); break; }
  }
  return { from: toYMD(fromDate), to: toYMD(toDate) };
}

// Deterministic muted palette by project id
export function getProjectColor(projectId) {
  const colors = ['#6B7280','#9CA3AF','#818CF8','#60A5FA','#34D399','#F59E0B','#F472B6'];
  const idx = Math.abs(Number(projectId) || 0) % colors.length;
  return colors[idx];
}
